import { IUserInfo } from '@utils/sharedTypes';

import { OrgRole } from 'shared/src/authz/rolesV2';
import { isOrgOwner, isUserOrgOwner } from 'shared/src/authz/validators';
import { TeamCompact } from 'shared/src/teams/types';
import { Product } from 'shared/src/types';
import { UserInfo } from 'shared/src/user/types';

const INSIGHTS_ALLOWED_LIST = [
  OrgRole.ADMIN,
  OrgRole.OWNER,
];

export function isOwner(userInfo: IUserInfo): boolean {
  return isUserOrgOwner(userInfo as UserInfo) || isOrgOwner(userInfo?.roles);
}

export function hasWorkspaceProductAccess(userInfo: UserInfo, workspaceName: string, product: string): boolean {
  const workspaceProductRoles = userInfo?.memberAccess?.productAccess?.[workspaceName];
  let productRole = true;

  switch (product) {
    case 'stream':
      productRole = workspaceProductRoles?.stream;
      break;
    case 'edge':
      productRole = workspaceProductRoles?.edge;
      break;
    case 'search':
      productRole = workspaceProductRoles?.search;
      break;
    case 'lake':
      productRole = workspaceProductRoles?.lake;
      break;
  }

  return productRole;
}

function isInsightsRole(userInfo: UserInfo): boolean {
  return userInfo?.roles?.some((role: OrgRole) => INSIGHTS_ALLOWED_LIST.includes(role));
}

export function hasWorkspaceSystemInsightsAccess(
  userInfo: UserInfo,
  cloudSystemInsightsEnabled: boolean,
  license: string | undefined,
): boolean {
  const isEnterprise = license === 'enterprise';

  return cloudSystemInsightsEnabled && isInsightsRole(userInfo) && isEnterprise;
}

export const hasTeamProductAccess = (
  teams: TeamCompact[] | undefined,
  product: Product,
  workspaceName: string,
): boolean => {
  if (!teams) {
    return false;
  }

  return teams.some(
    ({ roles, workspaceId }) => workspaceId === workspaceName && roles.some((role) => role.startsWith(product)),
  );
};
